module.exports = __webpack_public_path__ + "static/media/http.0fe6e29c.svg";